import { SxProps } from "@mui/material";

export const sxSubTitle: SxProps = {
    fontFamily: "UnimedSans-Bold",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "left",
    color: '#383838',
    width: '60%',
    '@media (max-width: 899px)': {
		width: '100%'
	},
}

export const sxText: SxProps = {
    fontFamily: "Unimed-Sans",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "left",
    color: '#4C4C4C',
    width: '60%',
    '@media (max-width: 899px)': {
		width: '100%'
	},
}

export const sxTextField: SxProps = {
	width: '100%',
	input: {
		fontFamily: 'Unimed-Sans', 
		color: '#383838', 
		fontSize: '14px', 
	},
	'@media (max-width: 899px)': {
		width: '100%'
	}
}

export const sxButtonText: SxProps = {
    textDecoration: 'underline',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    padding: 0,
    '&:hover': {
      color: '#164029',
    },
    color: '#383838'
}

export const sxButtonVoltar: SxProps = {
    alignSelf: 'flex-start',
    marginTop: 'auto',
}

export const sxAutocomplete: SxProps = {
    '.MuiAutocomplete-root': {
        
    },
    '.MuiOutlinedInput-root': {
        padding: '4px 4px 7.5px 5px',
        fontFamily: 'Unimed-Sans' 
    },
    width: '60%',
    '@media (max-width: 899px)': {
		width: '100%'
	},
}